export default {
  columnHeader: {
    simulatedDuration: 'Symulowany czas trwania',
  },
  acceptSimulatedDuration: 'Akceptuj symulowany czas trwania: {0}',
};
